class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  updateCartCount(count) {
    // Update mobile cart count - hide when zero
    const mobileCartCount = document.querySelector('.cart-count-bubble');
    if (mobileCartCount) {
      const countSpan = mobileCartCount.querySelector('span');
      if (countSpan) {
        countSpan.textContent = count;
      }
      mobileCartCount.style.display = count > 0 ? 'flex' : 'none';
    }
    
    // Update desktop cart count - always show, even when zero
    const desktopCartCount = document.querySelector('.desktop-cart-count');
    if (desktopCartCount) {
      desktopCartCount.textContent = ` (${count})`;
      desktopCartCount.style.display = 'inline'; // Always show on desktop
    }
  }
  
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    // Update drawer contents
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Parse the cart drawer section to get the actual item count
    try {
      const cartDrawerDOM = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
      const cartData = JSON.parse(cartDrawerDOM.querySelector('[data-cart-data]')?.textContent || '{}');
      if (cartData && typeof cartData.item_count !== 'undefined') {
        this.updateCartCount(cartData.item_count);
      }
    } catch (error) {
      console.error('Error parsing cart data:', error);
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// WORKS BUT NOT HEADER
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    console.log('THE GOODS',line, quantity, name)
    super.updateQuantity(line, quantity, name)?.then((response) => {
      console.log('wowow', response)
      if (!response) return;
      console.log('wowow2')

      try {
        console.log('updating quant')
        const cartDrawerDOM = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
        const cartData = JSON.parse(cartDrawerDOM.querySelector('[data-cart-data]')?.textContent || '{}');
        const cartDrawer = document.querySelector('cart-drawer');
        
        if (cartDrawer && cartData && typeof cartData.item_count !== 'undefined') {
          console.log('updating quant2')
          // Update cart drawer count
          cartDrawer.updateCartCount(cartData.item_count);
          
          // Update header cart count
          const cartCountBubble = document.querySelector('.cart-count-bubble');
          if (cartCountBubble) {
            console.log('updating quant3')
            const cartCount = cartCountBubble.querySelector('span');
            if (cartCount) {
              console.log('updating quant4')
              cartCount.textContent = cartData.item_count;
            }
            cartCountBubble.style.display = cartData.item_count > 0 ? 'flex' : 'none';
          }
          
          // Update desktop cart count - always show
          const desktopCartCount = document.querySelector('.desktop-cart-count');
          if (desktopCartCount) {
            console.log('updating quant5')
            desktopCartCount.textContent = ` (${cartData.item_count})`;
            desktopCartCount.style.display = 'inline';
          }
        }
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    });
  }
}

// NOT QUITE WORKING WITH UPDATING HEADER
// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       }
//     ];
//   }

//   updateQuantity(line, quantity, name) {
//     console.log('THE GOODS', line, quantity, name);
    
//     // Call super and store promise
//     const superPromise = super.updateQuantity(line, quantity, name);
//     console.log('Super promise:', superPromise);

//     // Create new promise to handle non-promise returns
//     return Promise.resolve(superPromise)
//       .then((response) => {
//         console.log('Response received:', response);
        
//         // If no response, fetch cart data directly
//         if (!response) {
//           console.log('No response, fetching cart data directly');
//           return fetch(window.Shopify.routes.root + 'cart?view=drawer');
//         }
        
//         // If we have a response, create a new response object with the sections
//         return new Response(JSON.stringify(response));
//       })
//       .then(response => response.text())
//       .then(responseText => {
//         console.log('Processing response text');
//         try {
//           const cartDrawerDOM = new DOMParser().parseFromString(responseText, 'text/html');
//           const cartData = JSON.parse(cartDrawerDOM.querySelector('[data-cart-data]')?.textContent || '{}');
//           const cartDrawer = document.querySelector('cart-drawer');
          
//           console.log('Cart data:', cartData);
          
//           if (cartDrawer && cartData && typeof cartData.item_count !== 'undefined') {
//             console.log('Updating counts with:', cartData.item_count);
//             cartDrawer.updateCartCount(cartData.item_count);

//             // Update drawer contents
//             this.getSectionsToRender().forEach((section => {
//               const elementToReplace =
//                 document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//               elementToReplace.innerHTML =
//                 this.getSectionInnerHTML(responseText, section.selector);
//             }));
//           }
//         } catch (error) {
//           console.error('Error processing cart data:', error);
//         }
//       })
//       .catch(error => {
//         console.error('Error in updateQuantity:', error);
//       });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       }
//     ];
//   }

//   updateQuantity(line, quantity, name) {
//     console.log('Updating quantity:', { line, quantity, name });
//     this.enableLoading(line);

//     // Get current quantity input and its constraints
//     const quantityInput = document.querySelector(`[data-quantity-variant-id="${line}"]`);
//     const lastValidQuantity = quantityInput?.getAttribute('data-cart-quantity') || 1;
//     const maxQuantity = parseInt(quantityInput?.getAttribute('data-inventory-quantity') || 0);

//     // Validate quantity before making request
//     if (maxQuantity > 0 && quantity > maxQuantity) {
//       this.handleErrorMessage(line, `Sorry, only ${maxQuantity} items are available`);
//       if (quantityInput) {
//         quantityInput.value = lastValidQuantity;
//       }
//       this.disableLoading();
//       return Promise.resolve();
//     }

//     const body = JSON.stringify({
//       line,
//       quantity,
//       sections: this.getSectionsToRender().map((section) => section.section),
//       sections_url: window.location.pathname
//     });

//     return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
//       .then((response) => response.json())
//       .then((response) => {
//         console.log('Cart update response:', response);

//         if (response.errors) {
//           throw new Error(response.errors);
//         }

//         try {
//           const cartDrawer = document.querySelector('cart-drawer');
//           if (cartDrawer) {
//             console.log('Updating counts with:', response.item_count);
//             cartDrawer.updateCartCount(response.item_count);

//             // Update sections
//             this.getSectionsToRender().forEach((section => {
//               const elementToReplace =
//                 document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//               if (elementToReplace && response.sections[section.section]) {
//                 elementToReplace.innerHTML =
//                   this.getSectionInnerHTML(response.sections[section.section], section.selector);
//               }
//             }));

//             // Update quantity input's data attribute with new valid quantity
//             if (quantityInput && !response.errors) {
//               quantityInput.setAttribute('data-cart-quantity', quantity.toString());
//             }

//             // Handle empty cart state
//             if (response.item_count === 0) {
//               cartDrawer.classList.add('is-empty');
//               const drawerInner = cartDrawer.querySelector('.drawer__inner');
//               if (drawerInner) {
//                 drawerInner.classList.add('is-empty');
//               }
//             }
//           }
//         } catch (error) {
//           console.error('Error updating cart:', error);
//           throw error;
//         }
//       })
//       .catch((error) => {
//         console.error('Error in updateQuantity:', error);
//         this.handleErrorMessage(line, error.message);
        
//         // Revert to last valid quantity on error
//         if (quantityInput) {
//           quantityInput.value = lastValidQuantity;
//         }
//       })
//       .finally(() => {
//         this.disableLoading();
//       });
//   }

//   handleErrorMessage(line, message) {
//     const errorElement = document.getElementById(`CartDrawer-LineItemError-${line}`);
//     if (errorElement) {
//       errorElement.querySelector('.cart-item__error-text').innerHTML = message;
//       errorElement.classList.remove('hidden');

//       setTimeout(() => {
//         errorElement.classList.add('hidden');
//       }, 5000);
//     }
//   }

//   enableLoading(line) {
//     const cartItems = document.getElementById('CartDrawer-CartItems');
//     if (cartItems) cartItems.classList.add('cart__items--disabled');

//     const loadingSpinner = document.querySelector('.loading-overlay__spinner');
//     if (loadingSpinner) loadingSpinner.classList.remove('hidden');

//     document.activeElement.blur();
//     this.lineItemStatusElement.setAttribute('aria-hidden', false);
//   }

//   disableLoading() {
//     const cartItems = document.getElementById('CartDrawer-CartItems');
//     if (cartItems) cartItems.classList.remove('cart__items--disabled');

//     const loadingSpinner = document.querySelector('.loading-overlay__spinner');
//     if (loadingSpinner) loadingSpinner.classList.add('hidden');
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }
// }

customElements.define('cart-drawer-items', CartDrawerItems);